<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12">
          <v-row class="justify-center align-center flex-column" v-if="isLoading">
            <p>Carregando...</p>
            <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
          </v-row>
          <v-snackbar v-model="snackbar" :color="resultSnack" :timeout="3000">
            {{ msg }}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
          <v-row class="justify-center" v-if="!isLoading">
            <v-col class="col-12 col-md-5">
              <div>
                <v-autocomplete
                  solo
                  flat
                  hide-no-data
                  clearable
                  label="Fuso horário"
                  :items="time_zone"
                  v-model="time_zone_name"
                  @change="timeZone"
                  background-color="#F7F7F7"
                ></v-autocomplete>
              </div>
              <div class="d-inline-flex primary--text">
                <v-icon class="mx-2" color="primary">calendar_today</v-icon>
                <h2>Agendamento</h2>
              </div>
              <v-col class="col-12 d-flex align-center justify-end my-3">
                <div
                  class="pl-12"
                  style="
                    background: #f7f7f7;
                    padding: 13px 0;
                    border-radius: 12px;
                    width: calc(100% - 46px);
                    position: relative;
                  "
                >
                  <div style="position: absolute; left: -50px; top: 0">
                    <v-avatar size="90">
                      <v-img v-if="user.photo != ''" :src="user.photo">
                        <template v-slot:placeholder>
                          <v-row fill-height align-center justify-center ma-0>
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-img
                        v-if="user.photo == ''"
                        :src="require('../../assets/no-image.png')"
                      ></v-img>
                    </v-avatar>
                  </div>
                  <p class="mb-2 font-weight-bold subheading">
                    {{ user.name }}
                  </p>
                  <p class="ma-0">
                    <span class="font-weight-bold">Nacionalidade:</span>
                    {{ user.country }}
                  </p>
                </div>
              </v-col>
              <v-date-picker
                v-model="date"
                :events="arrayEvents"
                full-width
                locale="pt-br"
                event-color="secondary"
                color="primary"
                :min="minDate"
                :picker-date.sync="pickerDate"
              ></v-date-picker>
              <div class="date__slected px-4 py-2">
                <p>
                  Data selecionada:
                  <span>{{ date | formatDate }}</span>
                </p>
              </div>
              <div class="my-3">
                <h3 class="primary--text">Horários Disponíveis</h3>
                <v-row class="row wrap px-3">
                  <v-radio-group v-model="selected">
                    <v-radio
                      class="list__hours"
                      v-for="(hour, index) in hoursOpen"
                      :key="index"
                      :label="hour.description"
                      :value="hour.value"
                    ></v-radio>
                  </v-radio-group>
                </v-row>
              </div>

              <div style="display: flex; flex-direction: column">
                <!-- <p class="lightGray pa-4 text-sm-center subheading font-weight-black">
                  Valor da consulta:
                  <span class="secondary--text ml-2">{{value}}</span>
                </p> -->
                <v-dialog v-model="dialog" persistent max-width="390">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      large
                      color="secondary"
                      style="align-self: center"
                      :loading="loader"
                      :disabled="isDisabled"
                      v-on="on"
                      v-if="userCategory === 'psychologist' && loggedUserId != user.id"
                    >
                      AGENDAR
                    </v-btn>
                    <p v-if="loggedUserId === user.id" class="text-center primary--text ma-0">
                      Você não pode se consultar como psicólogo.
                    </p>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Confirmar agendamento</v-card-title>
                    <v-card-text>
                      Tem certeza de que deseja realizar o agendamento?
                      <p class="font-weight-bold" v-if="userCategory === 'psychologist'">
                        Você deverá comparecer no devido horário para completar a análise do seu
                        perfil.
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray darken-1" text @click="dialog = false">Cancelar</v-btn>
                      <v-btn color="secondary darken-1" text @click="scheduleHours()">OK</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn
                  class="mt-6"
                  text
                  style="align-self: center"
                  @click="$router.go(-1)"
                  v-if="userCategory === 'psychologist'"
                  >Cancelar</v-btn
                >
              </div>
            </v-col>
            <v-col class="col-12 col-md-5" v-if="userCategory === 'patient'">
              <div class="mb-5">
                <p class="primary--text f-12 mb-2">Forma de Pagamento</p>
                <div v-if="!cartaoSelecionado">
                  <div
                    v-for="(card, i) in patientCards"
                    :key="i"
                    class="bg-secondaryGray d-flex flex-row align-center justify-space-between px-5 py-2 mt-3"
                  >
                    <div class="d-flex flex-column align-start justify-center">
                      <p class="ma-0 f-990 color-darkGray">Número</p>
                      <div class="d-flex flex-row align-center justify-center">
                        <p class="ma-0 f-12 primary--text font-weight-bold valor-cartao">
                          **** {{ card.number.substring(20, 14) }}
                        </p>
                      </div>
                    </div>
                    <div class="d-flex flex-column align-start justify-center">
                      <p class="ma-0 f-990 color-darkGray">Validade</p>
                      <p class="ma-0 f-12 primary--text font-weight-bold valor-cartao">
                        {{ card.due_date }}
                      </p>
                    </div>
                    <div class="d-flex flex-column flex-md-row align-center justify-center">
                      <v-btn
                        @click="selecionarCartao(card)"
                        class="f-880 w-100 mt-md-0 br-8"
                        color="success"
                        small
                        height="30"
                        style="width: 100px"
                      >
                        Selecionar
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-secondaryGray px-5 py-2 mt-3 mb-6" v-if="cartaoSelecionado">
                <div class="d-flex flex-row align-center justify-space-between">
                  <div class="d-flex flex-column align-start justify-center">
                    <p class="ma-0 f-990 color-darkGray">Número</p>
                    <div class="d-flex flex-row align-center justify-center">
                      <p class="ma-0 f-12 primary--text font-weight-bold valor-cartao">
                        **** {{ cartaoSelecionado.number.substring(20, 14) }}
                      </p>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-start justify-center">
                    <p class="ma-0 f-990 color-darkGray">Validade</p>
                    <p class="ma-0 f-12 primary--text font-weight-bold valor-cartao">
                      {{ cartaoSelecionado.due_date }}
                    </p>
                  </div>
                </div>
                <div class="text-center" style="margin-bottom: -20px">
                  <v-btn
                    @click="cartaoSelecionado = null"
                    class="bg-darkGray color-white br-8"
                    small
                    height="30"
                  >
                    Alterar Cartão
                  </v-btn>
                </div>
              </div>
              <div style="display: flex; flex-direction: column">
                <p class="lightGray pa-4 text-sm-center subheading font-weight-black">
                  Valor da consulta:
                  <span class="secondary--text ml-2">
                    {{
                      value.toLocaleString('pt-PT', {
                        style: 'currency',
                        currency: 'EUR',
                      })
                    }}
                  </span>
                </p>
                <v-dialog v-model="dialog" persistent max-width="390">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="patientCards.length === 0"
                      @click="dialogNoCards = true"
                      large
                      color="secondary"
                      style="align-self: center"
                      :loading="loader"
                    >
                      AGENDAR
                    </v-btn>
                    <v-btn
                      v-else
                      large
                      color="secondary"
                      style="align-self: center"
                      :loading="loader"
                      :disabled="isDisabled || !cartaoSelecionado"
                      v-on="on"
                    >
                      AGENDAR
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Confirmar agendamento</v-card-title>
                    <v-card-text>
                      <p class="font-weight-bold">
                        Tem certeza de que deseja realizar o agendamento?
                      </p>
                      <p class="font-weight-bold">
                        Se essa for a sua PRIMEIRA consulta com o terapeuta chefe, ela será de
                        graça!<br />
                        Ao clicar em Ok o seu agendamento será confirmado.<br />
                        No dia e horário da consulta o link para a vídeo chamada será
                        disponibilizada no detalhe da sua consulta.
                      </p>
                      <!-- <p class="font-weight-bold">
                        Caso não seja a primeira consulta com terapeuta chefe,
                        seu agendamento só será aprovado, caso realize o
                        pagamento pelo link que será enviado ao seu e-mail até
                        48hrs antes da consulta.
                      </p> -->
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray darken-1" text @click="dialog = false"> Cancelar </v-btn>
                      <v-btn color="secondary darken-1" text @click="scheduleHours()"> OK </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn class="mt-6" text style="align-self: center" @click="$router.go(-1)">
                  Cancelar
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-dialog v-model="dialogNoCards" persistent max-width="400">
            <v-card class="px-3 py-7">
              <v-card-title
                class="justify-center text-center font-weight-bold f-14 secondary--text pt-1 px-0"
                >Você não possui nenhuma forma de pagamento!</v-card-title
              >
              <v-card-text class="text-center color-darkGray px-0" style="line-height: 17px"
                >Você deseja criar agora a sua forma de pagamento para poder agendar
                consultas?</v-card-text
              >
              <v-card-actions class="justify-center">
                <v-btn
                  width="150"
                  height="40"
                  outlined
                  color="gray"
                  class="font-weight-bold"
                  @click="dialogNoCards = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  width="150"
                  to="/paciente/PaymentMethods/"
                  height="40"
                  class="bg-green color-white"
                  >Criar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import moment from 'moment-timezone';
import generalService from '../../services/general';
import { getCreditCards } from '../../services/patients';
import Api from '../../services/httpClient';

export default {
  data() {
    return {
      loader: false,
      isDisabled: true,
      isLoading: false,
      dialog: false,
      user: {},
      value: '',
      codPsi: '',
      selected: '',
      date: new Date().toISOString().substr(0, 10),
      arrayEvents: [],
      hoursOpen: [],
      page: 1,
      msg: '',
      snackbar: false,
      resultSnack: '',
      time_zone: moment.tz.names(),
      time_offset: '',
      time_zone_name: '',
      pickerDate: null,
      loggedUserId: null,
      userCategory: '',

      patientCards: [],
      cartaoSelecionado: null,
      dialogNoCards: false,
    };
  },
  async created() {
    await this.getCod();
    await this.getUser();
    await this.getTimeZone();
    await this.getHours();
    await this.getLocalUser();
    this.getUserCategory();
    await this.checkFirstTherapistConsultations();
    await this.getPatientCards();
  },
  computed: {
    /**
     * Informa para o datepicker a data minima para ser escolhida.
     */
    minDate() {
      const today = new Date();
      return this.formatDate(today);
    },
  },
  watch: {
    /**
     * Reconhece quando uma a variavel date é modificada e chama a
     * função que pegar as horas livres daquela data.
     */
    async date() {
      this.isDisabled = true;
      await this.getHours();
    },
    /**
     * Verifica que ocorreu uma alteração na variavel $selected
     * e desabilita o botão Agendar.
     */
    selected(val) {
      if (val !== '') {
        this.isDisabled = false;
      }
    },

    time_zone_name(val) {
      if (val) {
        this.getHours();
      }
    },

    pickerDate(val) {
      this.monthYear(val);
    },
  },
  methods: {
    selecionarCartao(cartao) {
      this.cartaoSelecionado = cartao;
    },
    async getPatientCards() {
      if (this.userCategory === 'patient') {
        this.isLoading = true;
        const res = await getCreditCards();
        this.patientCards = res;
        this.isLoading = false;
      }
    },
    async monthYear(value) {
      const res = value.split('-');
      const year = res[0];
      const month = res[1];
      if (year !== undefined && month !== undefined) {
        await this.allScheduleOpneMonth(month, year);
      }
    },
    getUserCategory() {
      const category = localStorage.getItem('user-category');
      this.userCategory = category;
    },
    /**
     * Pega o time zone escolhido pelo paciente
     */
    timeZone(val) {
      const m = moment().tz(val);
      this.time_offset = m.format('Z');
      this.time_zone_name = val;
    },
    /**
     * formata data e retorna para a função que vai informa ao datepicker
     * apartir de que data inicia.
     * params: $date
     */
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
    /**
     * Pega o id(codigo) do usuario que é passado vai parametro na rota.
     */
    getCod() {
      this.codPsi = this.$route.params.id;
    },
    getLocalUser() {
      const localUser = JSON.parse(localStorage.getItem('user-data'));
      console.log('localUser ', localUser);
      this.loggedUserId = localUser.id;
    },
    /**
     * Pega os dados do psicologo
     */
    getUser() {
      this.isLoading = true;
      Api.get(`/psychologists/${this.codPsi}/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      })
        .then((response) => {
          this.user = response.data;
          if (this.user.appointment_br_value === '0.00') {
            this.value = parseFloat(this.user.appointment_pt_value);
          } else {
            this.value = parseFloat(this.user.appointment_br_value);
          }
        })
        .catch((err) => {
          console.log(err.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * Pega todos os dias e horarios vagos aparti do mês e ano selecionado
     * e coloca em na variavel arrayEvents para ser sinalizado
     * no datapicker os dias que tem horarios vagos.
     */
    async allScheduleOpneMonth(month, year) {
      try {
        const { data, status } = await Api.get(
          `/psychologists/${this.codPsi}/time_slots/?year=${year}&month=${month}`,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );

        if (status === 200) {
          // eslint-disable-next-line no-restricted-syntax
          for (const item of data) {
            this.arrayEvents.push(item.date);
          }
        }
      } catch (error) {
        // console.log(error);
      }
    },
    getHours() {
      Api.get(`/psychologists/${this.codPsi}/time_slots/`, {
        params: {
          date: this.date,
        },
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      }).then((response) => {
        this.listHours(response.data);
        this.selected = '';
      });
    },
    /**
     * Através da array de horarios passado a função gera uma nova array
     * de objeos com value e description
     * { value 15:00, description 15h-16h}.
     */
    async listHours(val) {
      this.hoursOpen = [];

      const listFilter = await val.filter((item) => {
        const utcNow = `${moment.utc().format('YYYY-MM-DD HH:mm:ss')}`;
        const dateTime = `${item.date} ${item.time}`;
        return dateTime > utcNow;
      });

      // eslint-disable-next-line no-restricted-syntax
      for (const item of listFilter) {
        item.time = moment
          .utc(`${item.date} ${item.time}`)
          .tz(`${this.time_zone_name}`)
          .format('HH:mm:ss');
        const splitTime = item.time.split(':');
        let axuDesc = parseInt(splitTime[0], 10) + 1;
        // eslint-disable-next-line prefer-template
        axuDesc = ('0' + axuDesc).substr(-2);
        // eslint-disable-next-line prefer-template
        const auxDescription = `${item.time.replace(':00:00', 'h')}-${axuDesc}h`;
        const auxHours = {
          value: item.id,
          description: auxDescription,
        };
        this.hoursOpen.push(auxHours);
      }
    },
    /**
     * Agenda uma seção com o psicologo, passando o id da data/horario na URL
     * e como parametro o id do paciente.
     */
    async scheduleHours() {
      this.dialog = false;
      this.loader = true;
      const res = await this.checkFirstTherapistConsultations();
      Api.post(
        `/psychologists/${this.codPsi}/time_slots/${this.selected}/scheduling/`,
        {
          with_chief_therapist: true,
          patient_psychologist:
            this.userCategory === 'psychologist' ? localStorage.getItem('user-id') : null,
          patient: this.userCategory === 'patient' ? localStorage.getItem('user-id') : null,
          is_first: res === 204,
          creditCardId: this.userCategory === 'patient' ? this.cartaoSelecionado.id : null,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then(() => {
          this.isDisabled = true;
          this.msg = 'Agendamento realizado com sucesso!';
          // this.resultSnack = "success";
          this.snackbar = true;
          setTimeout(() => {
            if (this.userCategory === 'patient') {
              if (res === 204) {
                this.$router.replace('/paciente/formulario-terapeuta'); // vai pra tela de form de entrevista
              } else {
                this.$router.replace('/paciente/dashboard');
              }
            } else {
              // eslint-disable-next-line no-lonely-if
              if (res === 204) {
                this.$router.replace('/psicologo/formulario-terapeuta'); // vai pra tela de form de entrevista
              } else {
                this.$router.replace('/psicologo/dashboard');
              }
            }
          }, 3000);
        })
        .catch((err) => {
          this.$showSnackbar('Erro ao realizar o agendamento. Tente Novamente.');
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getTimeZone() {
      const dataUser = localStorage.getItem('user-data');
      this.time_zone_name = JSON.parse(dataUser).time_zone_name;
    },
    async checkFirstTherapistConsultations() {
      const { status } = await generalService.getFirstAppointments();
      return status;
    },
  },
};
</script>

<style scoped>
* >>> .list__hours {
  margin-top: 0px;
}

* >>> .list__hours .v-input--selection-controls__input {
  display: none;
}

* >>> .v-input--radio-group__input {
  display: flex;
  flex-direction: row !important;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

* >>> .list__hours {
  margin-bottom: 0;
  background: #cbcbcb;
  padding: 8px 16px;
  border-radius: 23px;
}

* >>> .list__hours.v-item--active {
  background: #02a554;
}

* >>> .list__hours.v-item--active .v-label {
  color: #fff;
}

* >>> .list__hours .v-label {
  color: #000000;
}

.date__slected {
  background-color: #e3ffe3;
}
.date__slected p {
  color: #6f6f6f;
  margin: 0;
  position: relative;
}
.date__slected p span {
  color: #02a554;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  right: 5px;
}

/* *>>> .v-date-picker-table .v-btn.v-btn--active,
*>>> .v-date-picker-table .v-btn.v-btn--outlined {
  border-radius: 28px;
} */
</style>
